import React from 'react'
import { Container } from 'reactstrap';
import Link from 'components/Link';
import Img from 'gatsby-image';
import { FormattedMessage } from 'react-intl';

export default (props) => {

  const { content, data } = props;

  const link = content.p4citeLink;
  return (
    <div>

    <div className="wrapper">
    <Img sizes={data.img.childImageSharp.sizes} />
    </div>

      <Container className="py-4">
     
        <h3 className="text-color-title">{content.title}</h3>
        <blockquote class="blockquote"><p>{content.headline}</p>
        <footer class="blockquote-footer"><FormattedMessage id="grandmaster"/> <cite title="Source Title"><FormattedMessage id="hedinn"/></cite></footer>
        </blockquote>
        <br />
        <p>{content.p1}</p>
        <br />
        <p>{content.p2}</p>
        <br />
        <p>{content.p3}</p>
        <br />
        <p>{content.p4} <a href={content.p4citeLink}>{content.p4cite}</a>{content.p4s}</p>
        <br/>
        <p>{content.p5}</p>
        <br />
        <p>{content.p6}</p>
        <br />

        <div className="text-center">
          <Link to="/" className="btn btn-success btn-lg">
            {content.download.line1} <br />
            {content.download.line2}
          </Link>
        </div>
      </Container>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/methods/patterns/_patternsLayout.js